<ada-card
	#ProductPropertiesCard
	id="ProductPropertiesCard"
	verticalSpacing="Small"
	width="100%"
	[collapseEnabled]="true"
>
	<ada-text
		content="Product Properties"
		data-container-selector="ada-card-header"
		id="ProductPropertiesCardHeader"
	/>
	<ada-container
		data-container-selector="ada-card-body"
		horizontalSpacing="Medium"
		verticalSpacing="Medium"
		[colCount]="4"
		[padding]="defaultCardPadding"
	>
		@if ('ScanSchedule' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization) {
			<ada-authoring-property-label
				content="Scan Schedule"
				[inheriting]="(currentPropertyObject?.ScanSchedule | inheritPipe: inheritedPropertyObject?.ScanSchedule) || isInheritanceDisabled"
				[isDisabled]="isDisabled"
				[isRequired]="'ScanSchedule' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('ScanSchedule')"
			/>
			<ada-object-list
				buttonText="Add Scan Schedule"
				data-testid="product-scanSchedule-list"
				[isDisabled]="isDisabled"
				[isMultiselect]="false"
				[javaClassName]="scheduleClassName"
				[objectIds]="currentPropertyObject?.ScanSchedule"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				(objectIdsChange)="setObjectPropertyValue('ScanSchedule', $event)"
			/>
		}

		@if ('MaintenanceWindowOverride' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization) {
			<ada-authoring-property-label
				#MaintenanceWindowOverrideLabel
				content="Maintenance Window Override"
				id="maintenance-window-override-label"
				[inheriting]="
					(currentPropertyObject?.MaintenanceWindowOverride | inheritPipe: inheritedPropertyObject?.MaintenanceWindowOverride) ||
					isInheritanceDisabled
				"
				[isDisabled]="isDisabled"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>

			<ada-object-list
				#MaintenanceWindowOverrideList
				data-testid="product-properties-maintenance-window-override-list"
				id="maintenance-window-override-list"
				[isDisabled]="isDisabled"
				[isMultiselect]="false"
				[javaClassName]="maintenanceWindowClassName"
				[objectIds]="currentPropertyObject?.MaintenanceWindowOverride"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				(objectIdsChange)="setObjectListOutput('MaintenanceWindowOverride', $event)"
			/>
		}

		@if ('RebootWindowOverride' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization) {
			<ada-authoring-property-label
				#RebootWindowOverrideLabel
				content="Reboot Window Override"
				id="reboot-window-override-label"
				[inheriting]="
					(currentPropertyObject?.RebootWindowOverride | inheritPipe: inheritedPropertyObject?.RebootWindowOverride) ||
					isInheritanceDisabled
				"
				[isDisabled]="isDisabled"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>

			<ada-object-list
				#RebootWindowOverrideList
				data-testid="product-properties-reboot-window-override-list"
				id="reboot-window-override-list"
				[isDisabled]="isDisabled"
				[isMultiselect]="false"
				[javaClassName]="maintenanceWindowClassName"
				[objectIds]="currentPropertyObject?.RebootWindowOverride"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				(objectIdsChange)="setObjectListOutput('RebootWindowOverride', $event)"
			/>
		}
	</ada-container>
</ada-card>
